import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchEPolicies() {
  const response = await instance.post(
    "/users/getHomePageData?userId=3&companyId=4"
  );
  return response.data;
}
export async function fetchLearningModule(data: any) {
  let query: any = [
    `moduleId=1`,
    `companyId=${data.companyId}`,
    `searchParam=${data.keyword}`,
    `offset=${data.offset}`,
  ];

  if (data?.categoryId) {
    query = [...query, `materialCategoryId=${data?.categoryId}`];
  }
  const response = await instance.post(
    `/material/getMaterialRecords?${query.join("&")}`
  );
  return response.data;
}

export async function fetchCounsellorModule(data: any) {
  let query: any = [
    `moduleId=2`,
    `companyId=${data.companyId}`,
    `searchParam=${data.keyword}`,
    `offset=${data.offset}`,
  ];

  const response = await instance.post(
    `/material/getMaterialRecords?${query.join("&")}`
  );
  return response.data;
}
export async function fetchAwarenessModule(data: any) {
  let query: any = [
    `moduleId=3`,
    `companyId=${data.companyId}`,
    `searchParam=${data.keyword}`,
    `offset=${data.offset}`,
  ];

  if (data?.categoryId) {
    query = [...query, `materialCategoryId=${data?.categoryId}`];
  }

  const response = await instance.post(
    `/material/getMaterialRecords?${query.join("&")}`
  );
  return response.data;
}
export async function fetchDocumentModule(data: any) {
  let query: any = [
    `moduleId=4`,
    `companyId=${data.companyId}`,
    `searchParam=${data.keyword}`,
    `offset=${data.offset}`,
  ];

  if (data?.categoryId) {
    query = [...query, `materialCategoryId=${data?.categoryId}`];
  }

  const response = await instance.post(
    `/material/getMaterialRecords?${query.join("&")}`
  );
  return response.data;
}

export async function fetchDocumentHelpModule(data: any) {
  let query: any = [
    `moduleId=5`,
    `companyId=${data.companyId}`,
    `searchParam=${data.keyword}`,
    `offset=${data.offset}`,
  ];

  const response = await instance.post(
    `/material/getMaterialRecords?${query.join("&")}`
  );
  return response.data;
}
export async function fetchInvestigatorModule(data: any) {
  let query: any = [
    `moduleId=6`,
    `companyId=${data.companyId}`,
    `searchParam=${data.keyword}`,
    `offset=${data.offset}`,
  ];

  const response = await instance.post(
    `/material/getMaterialRecords?${query.join("&")}`
  );
  return response.data;
}

export async function fetchCodeOfvoilationModule() {
  const response = await instance.get(`/code/getCodeViolations`);
  return response.data;
}
export async function fetchInsertMaterial(data: any) {
  const response = await instance.post(`/admin/material/insert`, data);
  return response.data;
}
export async function fetchUpdateMaterial(data: any) {
  const response = await instance.put(
    `/admin/material/update/${data.id}`,
    data.data
  );
  return response.data;
}
export async function fetchDeleteMaterial(id: any) {
  const response = await instance.delete(`/admin/material/delete/${id}`);
  return response.data;
}
export async function fetchCalendar(id: any) {
  const response = await instance.get(`/admin/calendar/get/1001`);
  return response.data;
}
export async function UpdateCalendar(data: any) {
  //  alert('hh')
  const response = await instance.put(
    `/admin/calendar/update/${data.id}`,
    data.data
  );
  return response.data;
}

export async function fetchInsertCodeVoilation(data: any) {
  //alert('hh')
  const response = await instance.post(`/admin/codeOfViolation/insert`, data);
  return response.data;
}
export async function fetchDeleteCVCompany(data: any) {
  //alert('hh')
  const response = await instance.delete(
    `/admin/codeOfViolation/delete/${data}`
  );
  return response.data;
}
export async function fetchDeleteCVCompanyRecords(data: any) {
  //alert('hh')
  const response = await instance.delete(
    `/code/deleteCodeViolationDetails/${data}`
  );
  return response.data;
}
export async function fetchInsertCompanyGroup(data: any) {
  //alert('hh')
  const response = await instance.post(
    `/code/addCodeViolationDetails/${data.id}`,
    data.data
  );
  return response.data;
}
export async function fetchUpdateCompanyGroup(data: any) {
  //alert('hh')
  const response = await instance.put(
    `/code/editCodeViolationDetails/${data.id}`,
    data.data
  );
  return response.data;
}
